export const Modal = {
  bindings: {
    target: '@',
    size: '@',
    onHide: '&',
    onHidden: '&',
    onShow: '&',
    onShown: '&',
  },

  transclude: {
    body: '?modalBody',
    title: '?modalTitle',
  },

  template: `
    <div
      id="{{ $ctrl.target }}"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="{{ $ctrl.target }}"
      aria-hidden="true">
      <div class="modal-dialog modal-{{ $ctrl.size || 'md' }}" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title w-100 text-center"
              ng-transclude="title">
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" ng-transclude="body"></div>
        </div>
      </div>
    </div>`,

  controller($timeout) {
    'ngInject';

    return {
      $onInit() {
        if (this.target) {
          $timeout(() => {
            $(`#${this.target}`)
              .on('hide.bs.modal', this.hide)
              .on('hidden.bs.modal', this.onHidden)
              .on('show.bs.modal', this.onShow)
              .on('shown.bs.modal', this.onShown);
          });
        }
      },

      $onDestroy() {
        $('.modal-backdrop').remove();

        if (this.target) {
          $(`#${this.target}`)
            .off('hide.bs.modal', this.hide)
            .off('hidden.bs.modal', this.onHidden)
            .off('show.bs.modal', this.onShow)
            .off('shown.bs.modal', this.onShown);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js